import { pageBreaks } from "./move";
import { getQuestionRangeWithId } from "./excelInfo";
import { getJson, getQuestionObj } from "./transform";

export async function importQuestion(
  sheetName: string,
  questionId: string,
  nextQuestionId?: string
) {
  try {
    const { rangeText, supplementCount, includePageBreak } = await getQuestionRangeWithId(
      questionId,
      nextQuestionId,
      sheetName
    );

    return await Excel.run(async (context) => {
      const sheet = context.workbook.worksheets.getItem(sheetName);

      let questionJson = await getJson(context, sheet, rangeText.replace("C", "B"));
      const from = reduceNumber(rangeText.split(":")[0], 1).replace("C", "B");
      const to = reduceNumber(rangeText.split(":")[0], 1).replace("C", "N");
      let prevRangeText = `${from}:${to}`;

      if (supplementCount) {
        const pageBreakRows = includePageBreak ? 1 : 0;
        const from = increaseNumber(rangeText.split(":")[0], pageBreakRows).replace("C", "B");
        const to = increaseNumber(rangeText.split(":")[0], pageBreakRows + supplementCount).replace(
          "C",
          "N"
        );
        prevRangeText = `${from}:${to}`;
      }

      // const nextRangeText =
      //   increaseNumber(rangeText.split(":")[1], 1).replace("N", "B") +
      //   ":" +
      //   increaseNumber(rangeText.split(":")[1], bufferRows);

      const prevJson = await getJson(context, sheet, prevRangeText);
      // const nextJson = await getJson(context, sheet, nextRangeText);

      const pageBrIndexPrev = prevJson.findIndex((row) => pageBreaks.includes(row["questionType"]));

      const questionObj = getQuestionObj(
        questionId,
        questionJson,
        prevJson.filter((_, i) => i >= pageBrIndexPrev)
        // nextJson
      );

      return questionObj;
    });
  } catch (error) {
    console.error("Error importing question:", error);
    return null;
  }
}

function reduceNumber(text: string, reduceBy: number = 1) {
  return text.replace(/(\d+)/g, (match) => {
    return Math.max(parseInt(match, 10) - reduceBy, 0).toString();
  });
}
function increaseNumber(text: string, reduceBy: number = 1) {
  return text.replace(/(\d+)/g, (match) => {
    return Math.max(parseInt(match, 10) + reduceBy, 0).toString();
  });
}
